import React from "react";
import Section from "Section";
import SplitPane from "components/SplitPane";
import DEMOED from "./media/demoed.png";
import HACKER from "./media/hacker.jpeg";
import EGGSTRONAUT from "./media/space.png";
import EGGSHIP from "./media/spaceship.png";
import PLANET from "./media/PLANET.png";
import SATURN from "./media/saturn.png";

import Form from "../components/NewsLetterSignup";
export default function Newsletter() {
  return (
    <Section bcolor="#27313B">
      <div className="newsletter">
        <SplitPane
          left={
            <>
              <div className="newsletter-con__left__planet-con">
                <img
                  src={PLANET}
                  alt=""
                  className="newsletter-con__left__planet-con__planet"
                />
              </div>
              <div>
                <img
                  src={EGGSHIP}
                  alt=""
                  className="newsletter-con__left__spaceship"
                />
              </div>
              <div className="newsletter-con__left__text">
                <h3>Sign up for newsletter</h3>
                Excited for RU Hacks 2022? Miss us from RU Hacks 2021? Want to
                be in the loop and hear about cool new events first? Whatever it
                may be, stay up to date by subscribing to our newsletter for
                monthly updates on events with our partners, sneak peeks into RU
                Hacks 2022, the journeys of our mascot Eggward and more!
                <div className="newsletter-con__left__signup">
                  <Form />
                </div>
              </div>
              <div className="newsletter-con__left__img">
                <img src={DEMOED} alt="" />
              </div>
            </>
          }
          right={
            <>
              <div>
                <img
                  src={EGGSTRONAUT}
                  alt=""
                  className="newsletter-con__right__eggstronaut"
                />
              </div>
              <div className="newsletter-con__right">
                <img
                  src={HACKER}
                  alt=""
                  className="newsletter-con__right__img"
                />
                <h3>Event Growth</h3>
                Throughout our six years, RU Hacks has grown into a large-scale
                event hosting up to 800+ hackers! We continue to integrate new
                and innovative ideas to improve our organization, in order to
                provide contestants with the most optimal experience. Our
                hackathon’s growth not only includes the amount of hackers
                present, but also extends to the number of judges, workshops,
                mentors, and networking opportunities, which are all available
                to each hacker that attends!
                <img
                  src={SATURN}
                  alt=""
                  className="newsletter-con__right__saturn"
                />
              </div>
            </>
          }
        />
      </div>
    </Section>
  );
}
